import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncTidalToSpotify() {
    return (
        <GuidesPage
            seoData={seoContent.syncTidalToSpotify}
            sections={<PairSyncGuideContent sourceKey="tidal" destKey="spotify" />}
        />
    );
}
